<template>
  <section>
    <transition
      name="fade"
      mode="out-in"
    >
      <!--
        Form input state
        Default state waiting for user input.
      -->
      <form
        @submit.prevent="onSubmit"
        v-if="formState === 'input'"
        class="c-form"
      >
        <h3 class="c-form__title">
          {{ title }}
        </h3>
        <div
          v-if="lead"
          v-html="lead"
          class="c-form__lead"
        />
        <p class="c-form__label-and-input">
          <label for="name">Fornavn*</label>
          <input
            id="name"
            v-model="formInput.firstName"
            type="text"
            name="firstName"
            required
          >
        </p>
        <p class="c-form__label-and-input">
          <label for="name">Etternavn*</label>
          <input
            id="name"
            v-model="formInput.lastName"
            type="text"
            name="lastName"
            required
          >
        </p>
        <p class="c-form__label-and-input">
          <label for="email">E-post*</label>
          <input
            id="email"
            v-model="formInput.email"
            type="email"
            name="email"
            required
          >
        </p>
        <p class="c-form__label-and-input">
          <label for="phone">Telefon*</label>
          <input
            id="phone"
            v-model="formInput.phone"
            type="text"
            name="phone"
            required
          >
        </p>
        <p class="c-form__label-and-input">
          <input
            id="consent"
            v-model="formInput.consent"
            :value="consent"
            type="checkbox"
            name="consent"
            required
          >
          <label for="consent">
            {{ consent }}
          </label>
        </p>
        <button
          :disabled="formInput.consent != true"
          type="submit"
          title="Du må godkjenne før du kan sende inn skjemaet"
          class="c-btn c-btn--secondary"
        >
          Send
        </button>
      </form>
  
      <!--
        Sending data state
        Waiting for response from make.com
      -->
      <div
        v-else-if="formState === 'sending'"
        class="c-form"
      >
        <h3 class="c-form__title">
          Sender data
        </h3>
        <p class="c-form__lead">
          Vi registrerer nå din interessemelding, vennligst vent.
        </p>
        <progress
          id="signup-progress-bar"
          class="c-form__progress"
          aria-label="Sender registrering"
        />
      </div>
  
      <!--
        Success state
        Data has been saved to Airtable
      -->
      <div
        v-else-if="formState === 'success'"
        class="c-form"
      >
        <h3
          class="c-form__title"
        >
          Tusen takk.
        </h3>
        <p class="c-form__lead">
          Vi har nå mottatt din melding og vil kontakte deg snarest.
        </p>
        <button 
          @click="showForm" 
          @keyup.enter="showForm" 
          type="button" 
          class="c-btn c-btn--secondary"
        >
          Vis skjemaet igjen
        </button>
      </div>
  
      <!--
        Error state
        Something wrong happened and data
        wasn't saved to Airtable
      -->
      <div
        v-else-if="formState === 'error'"
        class="c-form"
      >
        <h3 class="c-form__title">
          Feilmelding
        </h3>
        <p class="c-form__lead">
          Det har skjedd en feil med registreringen. Vi har ikke registrert din påmelding. Prøv gjerne igjen senere.
        </p>
        <p>
          <button
            @click="showForm()"
            type="button"
            class="c-btn c-btn--secondary"
          >
            Vis skjemaet igjen
          </button>
        </p>
      </div>
    </transition>
  </section>
</template>

<script>
import axios from 'axios';
//import { required, minLength, } from 'vuelidate/lib/validators';
//import querystring from 'querystring';

import Option from '@/models/Option';
import Residence from '@/models/Residence';
import Selector from '@/models/Selector';

export default {
  name: 'ContactForm',
  props: {
    residenceId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formInput: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        consent: '',
      },
      formState: 'input', // Possible values: 'input' || 'sending' || 'success' || 'error'
    };
  },
  computed: {
    residence() {
      return Residence.find(this.residenceId);
    },
    selector() {
      return Selector.query().first();
    },
    options() {
      return Option.query()
        .where('isSelected', true)
        .with('category')
        .get();
    },
    title() {
      return this.selector.contactFormTitle;
    },
    lead() {
      return this.selector.contactFormLead;
    },
    consent() {
      return this.selector.contactFormConcent;
    },
    info() {
      let values = {};
      values.firstName = this.formInput.firstName;
      values.lastName = this.formInput.lastName;
      values.email = this.formInput.email;
      values.phone = this.formInput.phone;
      values.consent = this.formInput.consent;
      values.unitId = this.residence.airtableId ? this.residence.airtableId : '';

      // TODO: Oppdatere med tilvalg
      /* values.options = '';
      this.options.forEach(option => {
        values.options +=
          option.category.name +
          ': ' +
          option.name +
          ', ' +
          option.currentPrice.toLocaleString('nb-NO') +
          ',–, \n';
      }); */
      return values;
    },
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      // Set form in sending state
      this.formState = 'sending';

      // Use Axios.js for sending data to make.com scenario using POST
      axios({
        method: 'post',
        // URL to Make.com webhook
        url: 'https://hook.eu1.make.com/nkc6lq9rht4zl3wpgqig95o5g5c5gk24',
        // Data object to be sent to Make.com scenario
        data: this.info,
      }).then(response => {
        // When the server responds set success message
        this.formState = 'success';

        // Register a Google Analytics event if GA is active on page.
        this.$gtag.event('generate_lead', {
          event_category: 'engagement',
          event_label: `Meld interesse for ${this.residence.name}`,
          value: 1,
        });
      }).catch(error => {
        // TODO: Create a better error reporting flow.
        console.log(error);
        // Set form in error state
        this.formState = 'error';
      });
    },
    showForm() {
      this.hideForm = false;
      this.formState = 'input';
    },
  },
};
</script>
